import React, { useEffect, useState } from 'react';
import Topbar from '../components/Header/Topbar';
import Navbar from '../components/Header/Navbar';
import Spinner from '../components/Spinner/Spinner';
import Footer from '../components/Footer/Footer';
import BackToTop from '../components/BackToTop/BackToTop';
import SEO from '../components/SEO/SEO';
import $ from 'jquery';

  const pageHeaderStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/assets/solar-banaer.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

const Contact = () => {
  const [result, setResult] = useState("");

  useEffect(() => {
    // Initialize WOW.js
    if (window.WOW) {
      new window.WOW().init();
    }

    // Hide spinner
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);

    // Back to top functionality
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });

    return () => {
      $(window).off('scroll');
      $('.back-to-top').off('click');
    };
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "387201d8-87b2-4ce9-9a44-7ed27cbcbff1");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
      setTimeout(() => setResult(""), 5000); // Clear message after 5 seconds
    } else {
      setResult("Error submitting form. Please try again.");
    }
  };

  return (
    <>
      <SEO 
        title="Contact Us"
        description="Get in touch with Galaxy Power System in Chidambaram. Contact us for batteries, inverters, and solar system inquiries or support."
        keywords="contact galaxy power system, battery shop contact, chidambaram battery support"
        canonicalUrl="https://galaxypowersystems.com/contact"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Contact', url: '/contact' }
        ]}
      />
      <Spinner />
      <Topbar />
      <Navbar />
      
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5" style={pageHeaderStyle}>
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">Contact Us</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/" className="text-white">Home</a></li>
              <li className="breadcrumb-item text-white active" aria-current="page">Contact</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Contact Content */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="display-6 mb-5">Get In Touch</h2>
              <form onSubmit={onSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input type="text" className="form-control" id="name" name="name" placeholder="Your Name" required />
                      <label htmlFor="name">Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input type="email" className="form-control" id="email" name="email" placeholder="Your Email" required />
                      <label htmlFor="email">Your Email</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input type="tel" className="form-control" id="phone" name="phone" placeholder="Your Phone" required />
                      <label htmlFor="phone">Your Phone</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input type="text" className="form-control" id="subject" name="subject" placeholder="Subject" required />
                      <label htmlFor="subject">Subject</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea className="form-control" placeholder="Leave a message here" id="message" name="message" style={{ height: '150px' }} required></textarea>
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary py-3 px-5" type="submit">Send Message</button>
                  </div>
                  {result && <div className="col-12"><span className="text-success">{result}</span></div>}
                </div>
              </form>
            </div>
            
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h2 className="display-6 mb-5">Contact Information</h2>
              <div className="d-flex mb-4">
                <div className="flex-shrink-0 btn-square bg-danger rounded-circle">
                  <i className="fa fa-map-marker-alt text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Address</h6>
                  <span>33/A1, VGP St, Chidambaram, Tamil Nadu 608601</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="flex-shrink-0 btn-square bg-danger rounded-circle">
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Phone</h6>
                  <span>+91 98657 57472</span>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div className="flex-shrink-0 btn-square bg-danger rounded-circle">
                  <i className="fa fa-envelope text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Email</h6>
                  <span>info@galaxypowersystem.com</span>
                </div>
              </div>
              <div className="d-flex">
                <div className="flex-shrink-0 btn-square bg-danger rounded-circle">
                  <i className="fa fa-clock text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Business Hours</h6>
                  <span>Mon - Sat: 09:00AM - 09:00PM</span><br />
                  <span>Sunday: Holiday</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      
       {/* Use the React BackToTop component */}
      <BackToTop />
    </>
  );
};

export default Contact;